/* import __COLOCATED_TEMPLATE__ from './general.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';
import type Session from 'embercom/services/session';

interface Args {
  selfAssignedSelection: any;
  saveSelfAssignSetting: (value?: boolean) => {};
  model: any;
  currentShowTeammatesPresence: any;
  updateTrackedProperty: (key: string, value: any) => {};
  initialInactivityEnabled: boolean;
  initialInactivityThreshold: number;
  followingInactivityEnabled: boolean;
  followingInactivityThreshold: number;
  autoAwaySetting: any;
  saveTeammatePresenceSettings: () => {};
  persistAutoAwaySetting: () => {};
  autoSnoozeEnabled: boolean;
  snoozeDuration: number;
  snoozeUnit: string;
  saveAutoSnoozeOnAwaySetting: () => void;
  autoPauseEnabled: boolean;
  saveAutoPauseOnAwaySetting: () => void;
  unassignUnsnoozedAtCapacityEnabled: boolean;
  unassignUnsnoozedAtCapacityUpdate: (value: boolean) => void;
  unassignUnsnoozedWhenAwayEnabled: boolean;
  unassignUnsnoozedWhenAwayAndReassignEnabled: boolean;
  unassignUnsnoozedWhenAwayUpdate: (
    value: boolean,
    mode: 'when_away_only' | 'when_away_and_reassign',
  ) => void;
}

export default class General extends Component<Args> {
  @service session!: Session;
  @service declare router: RouterService;
  @service declare intercomEventService: any;
  @service declare intl: IntlService;

  @action
  openWorkflows() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'go_to_workflows_button',
      place: 'assignments_settings',
      section: 'general_workflows',
    });
    this.router.transitionTo('apps.app.automation.workflows-overview', {
      queryParams: { workflowTemplateCategory: 'fin-workflows-wd' },
    });
  }

  @action
  showBannerArticle(articleId: number, eventObject: string) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: eventObject,
      place: 'assignments_settings',
      section: 'assignments_discovery_banner_methods',
    });
    window.Intercom('showArticle', articleId);
  }

  @action
  showBannerSetUpAssignmentsArticle() {
    this.showBannerArticle(6561699, 'set_up_assignments');
  }

  @action
  showBannerWorkloadManagementExplainedArticle() {
    this.showBannerArticle(6560715, 'workload_management_explained');
  }

  @action
  showBannerManageTeamPermissionsArticle() {
    this.showBannerArticle(3659500, 'manage_team_permissions');
  }

  get bannerLinks() {
    return [
      {
        id: 'set-up-assignments',
        text: this.intl.t(
          'new-settings.helpdesk.assignments.tabs.general.banner.links.set-up-assignments',
        ),
        onSelectItem: this.showBannerSetUpAssignmentsArticle,
        href: 'https://www.intercom.com/help/en/articles/6561699-assign-conversations-to-teammates-and-teams',
      },
      {
        id: 'workload-management-explained',
        text: this.intl.t(
          'new-settings.helpdesk.assignments.tabs.general.banner.links.workload-management-explained',
        ),
        onSelectItem: this.showBannerWorkloadManagementExplainedArticle,
        href: 'https://www.intercom.com/help/en/articles/6560715-workload-management-explained',
      },
      {
        id: 'manage-team-permissions',
        text: this.intl.t(
          'new-settings.helpdesk.assignments.tabs.general.banner.links.manage-team-permissions',
        ),
        onSelectItem: this.showBannerManageTeamPermissionsArticle,
        href: 'https://www.intercom.com/help/en/articles/3659500-manage-team-permissions',
      },
    ];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Helpdesk::Tabs::General': typeof General;
    'new-settings/helpdesk/tabs/general': typeof General;
  }
}
